import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [];
  static values = { data: Object };

  connect() {
    if (navigator.canShare) {
      this.element.classList.remove("hidden");
    }
  }

  async share() {
    if (navigator.share && navigator.canShare(this.dataValue)) {
      try {
        await navigator.share(this.dataValue);
      } catch (err) {
        console.log("Error", err);
      }
    }
  }
}
